import { Component, OnInit , OnDestroy, HostListener } from '@angular/core';
import { WorkService } from './services/work.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Observable, Subscription} from 'rxjs';
import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDropList } from '@angular/cdk/drag-drop';
import { pluck, switchMap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ViewModeDialog } from './team-header/view-mode-dialog.component';     
import { WorkUpdatesType, Navigation, TeamWorkFormatted, TeamFormatted, 
         WorkstationFormatted, PitchPair, Work, VariantConfig } from '../shared/models/type-list';
import { NavService } from '../nav/services/nav.service';
import { TeamService } from '../team-edit/services/team.service';
import { NgIf, NgFor, NgStyle, JsonPipe } from '@angular/common';
import { NavLink } from '../nav/nav-link/nav-link.component';
import { TeamHeader } from './team-header/team-header.component';
import { Pitch } from './pitch/pitch.component';

@Component({
    selector: 'app-team-work',
    templateUrl: './team-work.component.html',
    styleUrls: ['./team-work.component.scss'],
    imports: [NgIf, NavLink, TeamHeader, CdkDropList, NgFor, NgStyle, Pitch, JsonPipe]
})

export class TeamWorkComponent implements OnInit, OnDestroy {
  workFormattedSubscription: Subscription = new Subscription();
  twoSided: Boolean = false
  minHeight: string = '';
  containerminHeight : string = '';
  emptyMinHeight: string = '';
  isExpanded : boolean = false
  viewOnly: boolean = true
  viewOnlyUserConfirm: boolean = false
  baseVariant: number = 0;
  multiplierValue: number = 0;
  currentNav: Navigation = {
    plant_name: '',
    line: '',
    subline: '',
    team_id: 0,
    version_id: 0
  }
  teamType:string = '';
  teamFormattedInfo: TeamFormatted = <TeamFormatted>{};
  oddWorkstations: WorkstationFormatted[] = [];
  evenWorkstations: WorkstationFormatted[] = [];
  pitchPairs: PitchPair[] = []
  pitchesDisplayed: PitchPair[] = []
  workstationAllListArray: string[] = []
  workstationParentListArray: string[] = []
  workstationFluctuationArray: string[] = []
  workstationPeriodicArray: string[] = []
  workstationCycleWasteArray: string[] = []
  workstationPlaceholderArray: string[] = []
  pitchSaves: WorkstationFormatted[] = []
  saveStatus: any = {
    message: "",
    color: "primary"
  }
  displayErgoScore: Boolean = false;
  scrollTimeoutId: any;
  resizeListener: any;
  refreshSubscription: Subscription = new Subscription;

  variantConfig: VariantConfig[] = [];
  teamBaseVariant: VariantConfig = <VariantConfig>{};


  constructor(
    private workService: WorkService,
    private route: ActivatedRoute,
    private _snackbar: MatSnackBar,
    private viewModeDialog: MatDialog,
    private navService: NavService,
    private teamService: TeamService
  ){
    this.currentNav.plant_name = this.route.snapshot.paramMap.get('plant_name') ?? '';
    this.currentNav.team_id = Number(this.route.snapshot.paramMap.get('team'));
    this.currentNav.version_id = Number(this.route.snapshot.paramMap.get('version'));
  }
  
  canDeactivate(): boolean {
    if (this.saveStatus.message == 'Unsaved Changes'){
      const result = window.confirm('Unsaved Changes will be lost.');
      return result
    }
    return true;
  }
    

  ngOnInit() {
    this.navService.setCurrentTeamID(+this.currentNav.team_id);
    this.getTeamWork();
    this.refreshSubscription = this.teamService.workPitchRefresh$.subscribe((val) => {
      if(val === true) {
        this.getTeamWork();
      }
    });
     this.setUpAutoScroll();
  }

  setUpAutoScroll() {
    if (this.scrollTimeoutId) {
      clearTimeout(this.scrollTimeoutId);
    }
 
    // Give time for async content to render then scroll the vertical wrapper to center
    this.scrollTimeoutId = setTimeout(() => {
      const wrapper = document.querySelector('.scrolling-wrapper') as HTMLElement;
      if (!wrapper) return;
      // Determine if any pitch pair has an even workstation visible. If any even exists,
      // scroll the wrapper to 50% (center). If no even exists, scroll to the bottom.
      let hasEven = false;
      try {
        hasEven = this.pitchPairs && this.pitchPairs.some(p => {
          const even = p && p.even;
          return even !== undefined && even !== null && Object.keys(even).length > 0;
        });
      } catch (err) {
        hasEven = false;
      }
 
      const totalHeight = wrapper.scrollHeight;
      const viewportHeight = wrapper.clientHeight;
 
      if (hasEven) {
        // Scroll to vertical center (50%) so both top and bottom are visible
        const centerPosition = (totalHeight - viewportHeight) / 2;
        const targetTop = Math.max(0, Math.min(centerPosition, totalHeight - viewportHeight));
        try {
          wrapper.scrollTo({ top: targetTop, behavior: 'smooth' });
        } catch (e) {
          wrapper.scrollTop = targetTop;
        }
      } else {
        // No even workstations present: scroll to the bottom
        const bottom = Math.max(0, totalHeight - viewportHeight);
        try {
          wrapper.scrollTo({ top: bottom, behavior: 'smooth' });
        } catch (e) {
          wrapper.scrollTop = bottom;
        }
      }
 
      // Remove previous listener if present to avoid duplicates
      if (this.resizeListener) {
        window.removeEventListener('resize', this.resizeListener);
      }
 
      // Resize handler should re-evaluate presence of even workstations and re-apply correct scroll
      this.resizeListener = () => {
        const newWrapper = document.querySelector('.scrolling-wrapper') as HTMLElement;
        if (!newWrapper) return;
        let newHasEven = false;
        try {
          newHasEven = this.pitchPairs && this.pitchPairs.some(p => {
            const even = p && p.even;
            return even !== undefined && even !== null && Object.keys(even).length > 0;
          });
        } catch (err) {
          newHasEven = false;
        }
 
        const newTotal = newWrapper.scrollHeight;
        const newView = newWrapper.clientHeight;
        if (newHasEven) {
          const newCenter = Math.max(0, Math.min((newTotal - newView) / 2, newTotal - newView));
          try { newWrapper.scrollTo({ top: newCenter, behavior: 'smooth' }); } catch (e) { newWrapper.scrollTop = newCenter; }
        } else {
          const newBottom = Math.max(0, newTotal - newView);
          try { newWrapper.scrollTo({ top: newBottom, behavior: 'smooth' }); } catch (e) { newWrapper.scrollTop = newBottom; }
        }
      };
      window.addEventListener('resize', this.resizeListener);
    }, 600); // a moderate delay so content and measurements stabilize
  }


  ngOnDestroy() {
    if (this.workFormattedSubscription) this.workFormattedSubscription.unsubscribe();
    if (this.refreshSubscription) this.refreshSubscription.unsubscribe();
    if(this.scrollTimeoutId) {
      clearTimeout(this.scrollTimeoutId);
    }
    if(this.resizeListener){
      window.addEventListener('resize', this.resizeListener);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    if (this.pitchSaves.length > 0){
      event.preventDefault();
      event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
      return false;
    }
  }

  getTeamWork(){
    this.pitchPairs = []

    let workObservable: Observable<TeamWorkFormatted> =
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
       this.workService.getWorkFormatted(this.currentNav.team_id, this.currentNav.version_id)),
       pluck('Body'));

    if (this.workFormattedSubscription) this.workFormattedSubscription.unsubscribe();     
       
    this.workFormattedSubscription = workObservable.subscribe((out) => { 
      console.info('Read',out)
      this.teamFormattedInfo = out.team_version_info
      this.variantConfig = out.variant_config
      let baseIndex: number = -1
      console.log('VCT Base Variant ID:', this.teamFormattedInfo.base_variant_id)
      console.log('VCT Variant Config:', this.variantConfig)
      this.variantConfig.forEach(v => {
        console.log('VCT Variant ID:', v.variant_id)
      })
      baseIndex = this.variantConfig.findIndex(v => v.variant_id === this.teamFormattedInfo.base_variant_id)
      console.log('VCT BI:', baseIndex)
      if (baseIndex != -1){
        this.teamBaseVariant = this.variantConfig[baseIndex] 
      }
      console.log('VCT Base Variant: ', this.teamBaseVariant)
      
      console.log('VCT TFI:', this.teamFormattedInfo)
      console.log('VCT Get Team Work: ', this.teamFormattedInfo.variant_cycle_times)

      this.teamType = out.team_version_info.team_type? out.team_version_info.team_type : '';

      this.createPitchPairs(out.odd_workstations, out.even_workstations)
      this.pitchesDisplayed = this.pitchPairs

      //multiplier value for determining workblock, pitch, and variant box sizes
      if  (this.teamFormattedInfo.takt_time > 60 &&  this.teamFormattedInfo.takt_time < 1000)
          this.multiplierValue = 3
      else if(this.teamFormattedInfo.takt_time > 1000) 
          this.multiplierValue = 1
      else
        this.multiplierValue = 15
      
      this.calculateWorkMinHeight()
      console.log('finish')
      this.setUpAutoScroll();
    }) 
  }

  updateCycleStats(){
    console.log('Read Update Cycle Stats')
    let baseIndex: number = 0
    let excludeTypes: string[] = ['waterspider', 'repacker', 'kitter'];

    let baseVariant: VariantConfig = <VariantConfig>{};

    baseIndex = this.variantConfig.findIndex(v => v.variant_id === this.teamFormattedInfo.base_variant_id)
    if (baseIndex != -1)
      baseVariant = this.variantConfig[baseIndex]
    
    console.log('Base Variant', baseVariant)

    this.teamFormattedInfo.actual_processes = 0
    this.teamFormattedInfo.base_cycle_time = 0
    this.teamFormattedInfo.theoretical_processes = 0
    console.log('VCT TFI',this.teamFormattedInfo)

    this.teamFormattedInfo.variant_cycle_times.forEach(v =>{
      console.log('VCT Variant', v)
      v.cycle_time = 0
      v.actual_processes = 0
      v.theoretical_processes = 0
    });

    console.log('VCT Variant Cycle Times', this.teamFormattedInfo.variant_cycle_times)


    this.pitchPairs?.forEach(pitch =>{
      console.log('VCT Pitch: ', pitch)
      let pitchTeamVariants = []
      if (pitch?.odd){
        pitchTeamVariants = pitch.odd.variant?.map(variant => variant.variant_id)
      } else {
        pitchTeamVariants = pitch.even.variant?.map(variant => variant.variant_id)
      }
      
      let pitchModelVariants: any = []
      pitchTeamVariants?.forEach(variant =>{
        let variantIndex = this.variantConfig.findIndex(v => v.variant_id === variant)
        if (variantIndex != -1){
          pitchModelVariants = [...pitchModelVariants,...this.variantConfig[variantIndex]['model_variants']?.map(model=>model.model_id)]
        }
      })
      console.log('VCT Pitch ODD', pitch.odd)
      if (pitch.odd && !excludeTypes.includes(pitch.odd?.type)){
        pitch.odd?.variant?.forEach(variant => {
          console.log('Pitch Odd: ', pitch.odd?.pitch_id)
          variant.work.cycle.forEach(work => {
            if (variant.variant_id == this.teamFormattedInfo.base_variant_id){
              console.log('VCT Base', variant.variant_id)
              this.teamFormattedInfo.variant_cycle_times.forEach(v => {
                console.log('VCT', pitchModelVariants, baseVariant.model_variants, v.variant_id)
                if (!pitchModelVariants.includes(v.variant_id) || baseVariant.model_variants.some(m => m.model_id == v.variant_id)){
                  console.log('VCT Base ODD', v.variant_id) 
                  v.cycle_time += work.time_to_complete
                  v.actual_processes += 1
                  v.theoretical_processes += work.time_to_complete/pitch.odd?.takt_time
                }
              })
            } else {
              console.log('Team', variant.variant_id)
              console.log('VCT Pitch ODD', pitch.odd?.pitch_id)
              let teamVariantIndex = this.variantConfig.findIndex(v => v.variant_id === variant.variant_id)
              console.log('VCT Team Variant Index', teamVariantIndex)
              if (teamVariantIndex != -1){
                console.log('VCT Team Variant', this.variantConfig[teamVariantIndex])
                this.variantConfig[teamVariantIndex]['model_variants'].forEach(model => {
                  
                  let modelIndex = this.teamFormattedInfo.variant_cycle_times.findIndex(v => v.variant_id === model.model_id)
                  if (modelIndex != -1){
                    this.teamFormattedInfo.variant_cycle_times[modelIndex].cycle_time += work.time_to_complete
                    this.teamFormattedInfo.variant_cycle_times[modelIndex].actual_processes += 1
                    this.teamFormattedInfo.variant_cycle_times[modelIndex].theoretical_processes += work.time_to_complete
                  };
                });
              };
            };
          });
        });
      }


      console.log('VCT Pitch EVEN', pitch.even)
      if (pitch.even &&!excludeTypes.includes(pitch.even?.type)){
        pitch.even?.variant?.forEach(variant => {
          console.log('Pitch Even: ', pitch.even?.pitch_id)
          variant.work.cycle.forEach(work => {
            if (variant.variant_id == this.teamFormattedInfo.base_variant_id){
              console.log('Base', variant.variant_id)
              this.teamFormattedInfo.variant_cycle_times.forEach(v => {
                if (!pitchModelVariants.includes(v.variant_id) || baseVariant.model_variants?.map(m => m.model_id).includes(v.variant_id)){
                  console.log('VCT Base', v.variant_id) 
                  console.log('Base', v.variant_id) 
                  v.cycle_time += work.time_to_complete
                  v.actual_processes += 1
                  v.theoretical_processes += work.time_to_complete/pitch.odd?.takt_time
                }
              })
            } else {
              console.log('Team', variant.variant_id)
              let teamVariantIndex = this.variantConfig.findIndex(v => v.variant_id === variant.variant_id);
              if (teamVariantIndex != -1){
                this.variantConfig[teamVariantIndex]['model_variants'].forEach(model => {
                  
                  let modelIndex = this.teamFormattedInfo.variant_cycle_times.findIndex(v => v.variant_id === model.model_id);
                  if (modelIndex != -1){
                    this.teamFormattedInfo.variant_cycle_times[modelIndex].cycle_time += work.time_to_complete;
                    this.teamFormattedInfo.variant_cycle_times[modelIndex].actual_processes += 1;
                    this.teamFormattedInfo.variant_cycle_times[modelIndex].theoretical_processes += work.time_to_complete/pitch.even?.takt_time;
                  };
                });
              };
            }
          })
        });
      }
    })

    console.log('VCT Variant Cycle Times', this.teamFormattedInfo.variant_cycle_times)


    let maxSigmaVariant = this.teamFormattedInfo.variant_cycle_times.reduce(
      (prev, curr) => (curr.cycle_time > prev.cycle_time ? curr : prev),
      this.teamFormattedInfo.variant_cycle_times[0]
    );

    if(maxSigmaVariant) {
      this.teamFormattedInfo.base_cycle_time = maxSigmaVariant.cycle_time;
      this.teamFormattedInfo.actual_processes = maxSigmaVariant.actual_processes;
      this.teamFormattedInfo.theoretical_processes = maxSigmaVariant.theoretical_processes;

      //this.teamFormattedInfo.variant_cycle_times = 
        //this.teamFormattedInfo.variant_cycle_times.filter(
          //(v) => v.variant_id !== maxSigmaVariant.variant_id
        //);
      //this.teamFormattedInfo.variant_cycle_times.unshift(maxSigmaVariant)
    }
    
  }


  drop(event: CdkDragDrop<string[]>) {
    console.log('Drag' + event)   
    let validMovement: boolean = true

    if (!this.viewOnlyUserConfirm && this.viewOnly) {
      this.viewModeDialog.open(ViewModeDialog, {
        width: '500px'
      });
      this.viewOnlyUserConfirm = true
    }

    //Parse out current drop values - the pitch/variant into which the work is dropped
    let currentFirstDash = event.container.id.indexOf('-')
    let currentSecondDash = event.container.id.indexOf('-', currentFirstDash + 1)

    let currentIndex: number = -1
    let currentPitchSide: any = ''
    let currentPitchIndex: any = -1
    let currentPitch = Number(event.container.id.substring(0, currentFirstDash))
    let currentVariantIndex: any = -1
    let currentVariant = Number(event.container.id.substring(currentFirstDash + 1, currentSecondDash))
    let currentContainerID = event.container.id.substring(0, currentSecondDash) 
    
    currentPitchIndex = this.pitchPairs.map(pitch => pitch.odd).findIndex(oddPitch => oddPitch.pitch_config_id === currentPitch)
    if (currentPitchIndex == -1){
      currentPitchIndex = this.pitchPairs.map(pitch => pitch.even).findIndex(evenPitch => evenPitch.pitch_config_id === currentPitch)
      if (currentPitchIndex != -1)
        currentPitchSide = 'even'
    } else
      currentPitchSide = 'odd'
    
    if (currentPitchIndex !== -1) {
      const currentPitch = this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair];
      if (currentPitch) currentVariantIndex = currentPitch.variant.findIndex(variant => variant.variant_id === currentVariant);
    }

    //Parse out previous drag values - the pitch/variant from which the work is dragged
    let previousFirstDash = event.previousContainer.id.indexOf('-')
    let previousSecondDash = event.previousContainer.id.indexOf('-', previousFirstDash + 1)

    let previousIndex: number = -1
    let previousPitchIndex: number = -1
    let previousPitchSide: string = ''
    let previousPitch = Number(event.previousContainer.id.substring(0, previousFirstDash))
    let previousVariantIndex: number = -1
    let previousVariant = Number(event.previousContainer.id.substring(previousFirstDash + 1, previousSecondDash))
    let previousContainerID = event.previousContainer.id.substring(0, previousSecondDash)
    
    previousPitchIndex = this.pitchPairs.map(pitch => pitch.odd).findIndex(oddPitch => oddPitch.pitch_config_id === previousPitch)
    if (previousPitchIndex == -1){
      previousPitchIndex = this.pitchPairs.map(pitch => pitch.even).findIndex(evenPitch => evenPitch.pitch_config_id === previousPitch)
      if (previousPitchIndex != -1)
        previousPitchSide = 'even'
    } else
      previousPitchSide = 'odd'
    
    if (previousPitchIndex !== -1) {
      const previousPitch = this.pitchPairs[previousPitchIndex][previousPitchSide as keyof PitchPair];
      if (previousPitch) previousVariantIndex = previousPitch.variant.findIndex(variant => variant.variant_id === previousVariant);
    }
    
    //Determines current index
    if (currentPitchSide == 'odd'){
      if (event.container.id.includes('placeholder'))
        currentIndex = event.currentIndex
      else {
        if(previousPitch == currentPitch && previousVariant == currentVariant)
          currentIndex = (event.container.data.length -1) - event.currentIndex
        else
          currentIndex = (event.container.data.length) - event.currentIndex
      }
    } else if (currentPitchSide == 'even') 
      currentIndex = event.currentIndex

    // Determines previous index
    if (previousPitchSide == 'odd'){
      if (event.previousContainer.id.includes('cycle') || event.previousContainer.id.includes('waste'))
        previousIndex = (event.previousContainer.data.length - 1) - event.previousIndex
      else
        previousIndex = event.previousIndex
    } else if (previousPitchSide == 'even')
      previousIndex = event.previousIndex

    //Movement
    console.log('Current: ', currentIndex)
    console.log('Previous: ', previousIndex)
    if (currentContainerID == previousContainerID){
      moveItemInArray(event.container.data, previousIndex, currentIndex)
      if (!this.viewOnly){
        this.pitchSaves.push(this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair])
        this.saveStatus.message = 'Unsaved Changes'
        this.saveStatus.color = 'red'
      }
    } else {
      //Pitch Movement Validation: from one pitch/variant to another pitch/variant
      if (event.previousContainer.id.includes('fluctuation')){
        let fluctuationLength = this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].variant[currentVariantIndex].work.fluctuation.length
        if (fluctuationLength > 0)
          validMovement = false
      }

      if (this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].status == 'blocked'||
          this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].status == 'covered by another team')
            validMovement = false
      
      console.info("Movement Validation Result: ", validMovement)
      if (validMovement){
        transferArrayItem(event.previousContainer.data, event.container.data, previousIndex, currentIndex)

        const sourcePitchObj = this.pitchPairs[previousPitchIndex][previousPitchSide as keyof PitchPair];
        const targetPitchObj = this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair];

        // helper to count all work inside a pitch
        const getTotalWorkCount = (pitch: any) => {
          if (!pitch || !pitch.variant) return 0;

          let count = 0;
          pitch.variant.forEach((v: any) => {
            count += (v.work.cycle?.length || 0);
            count += (v.work.fluctuation?.length || 0);
            count += (v.work.periodic?.length || 0);
          });
          return count;
        };

        // if source pitch becomes empty → OPEN
        if (getTotalWorkCount(sourcePitchObj) === 0) {
          sourcePitchObj.status = 'open';
        }

        // if target pitch has work → ACTIVE
        if (getTotalWorkCount(targetPitchObj) > 0) {
          targetPitchObj.status = 'active';
        }

        //Clean up placeholder array, it should always default back to empty
        if (event.container.id.includes('placeholder')){
          let workType: any = event.previousContainer.id.substring(previousSecondDash + 1)
          let index: any = this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].variant[currentVariantIndex].work[workType].length
          this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].variant[currentVariantIndex].work[workType][index] = this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].variant[currentVariantIndex].work.placeholder[0]
          delete this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].variant[currentVariantIndex].work.placeholder[0]
        }


        //Add pitch changes to array for pitches to be saved
        this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair].status = 'active'
        if (!this.viewOnly){
          this.pitchSaves.push(this.pitchPairs[currentPitchIndex][currentPitchSide as keyof PitchPair])
          this.pitchSaves.push(this.pitchPairs[previousPitchIndex][previousPitchSide as keyof PitchPair])
          this.saveStatus.message = 'Auto Saved'
          this.saveStatus.color = '#0277BD'
          this.saveWork()
        }
        this.updateCycleStats();
        this.calculateWorkMinHeight();
      }
    }
  }

  saveWork(){
    let updates: WorkUpdatesType[] = []

    this.pitchSaves.forEach(pitch => {
      pitch.variant.forEach(variant => {
        Object.keys(variant.work).forEach(key =>{
          let sortOrder = 0
          if (key == 'cycle' || key == 'periodic' || key == 'fluctuation'){
            this.sortWork(variant.work[key])

            variant.work[key].forEach(work => {

              let update: WorkUpdatesType = {
                pitchConfigID: pitch.pitch_config_id,
                workID: work.work_id,
                variantID: variant.variant_id,
                sortOrder: work.sort_order,
                pitchID: pitch.pitch_id,
                variantName: variant.variant_name,
                workType: work.type,
                workDescription: work.description
              }
              updates.push(update)
            })
          }
        })
      })
    })
    console.log(updates)

    if(updates.length != 0){
      this.workService.saveTeamWork(this.currentNav.plant_name, this.teamFormattedInfo.team_id, this.teamFormattedInfo.version_id, updates).subscribe(result => {
        this.getTeamWork();
        if(result["Body"] > 0){
          let message = "Saved";
          let action = "";
          this._snackbar.open(message, action, {duration: 2000,});
        }
      });
    }
    this.pitchSaves = [];
  }

  sortWork(work: Work[]){
    let sortOrder: number = 0
    work.forEach((w, i) => {
      if (w.type == 'waste'){
        sortOrder = Math.floor(sortOrder) + 0.5
      } else {
        sortOrder = Math.floor(sortOrder) + 1
      }
      w.sort_order = sortOrder
    })
  }

  calculateWorkMinAfterCollapse(pitch:WorkstationFormatted){
    this.isExpanded = false;
    pitch.isexpanded = false;
    this.calculateWorkMinHeight();
  }

  calculateWorkMinAfterExpand(pitch:WorkstationFormatted){
    this.isExpanded = true;
    pitch.isexpanded = true;
    this.calculateWorkMinHeight();
  }

  calculateWorkMinHeight(){
    console.info('Calculate Work Min Height')

    let placeholderPadding : number = 5;
    let minHeight: number;
    let calcMinHeight: number;
    let maxPeriodicWork : number = 0;
    let expansionHeader : number = 5;
    let containerHeader : number = 240;

    if (this.teamFormattedInfo.takt_time > 60 && this.teamFormattedInfo.takt_time < 1000)
      placeholderPadding = 20
    else if (this.teamFormattedInfo.takt_time > 1000)
      placeholderPadding = 60
 
    minHeight = (this.teamFormattedInfo.takt_time + 1);
    this.pitchPairs.forEach(pitch => {
      (Object.keys(pitch) as Array<keyof PitchPair>).forEach(key => {
        if (pitch[key] && pitch[key].hasOwnProperty('variant')){
          //work through variant's work to calculate needed height for a pitch
          pitch[key].variant.forEach(variant=> {
            if (pitch[key].takt_time + placeholderPadding > minHeight)
              minHeight = pitch[key].takt_time + placeholderPadding

            calcMinHeight = 0;
            maxPeriodicWork = 0;
  
            calcMinHeight = calcMinHeight + variant.work.fluctuation.map(work => work.time_to_complete).reduce((prev, curr) => prev + curr, 0)
    
            if (variant.work.periodic.length > 0)
              maxPeriodicWork = Math.max(...variant.work.periodic.map(out => out.time_to_complete))

            calcMinHeight = calcMinHeight + maxPeriodicWork
            pitch[key].expandedhgt = variant.work.periodic.map(work => work.time_to_complete).reduce((prev, curr) => prev + curr, 0)

    
            calcMinHeight += variant.work.cycle.map(work => work.time_to_complete).reduce((prev, curr) => prev + curr, 0)
            
            if (pitch[key].isexpanded == true){
              this.isExpanded = true
              calcMinHeight = (calcMinHeight - maxPeriodicWork) + expansionHeader + pitch[key].expandedhgt;
            }
            
            calcMinHeight = calcMinHeight + placeholderPadding

            if  (calcMinHeight > minHeight)
              minHeight = calcMinHeight
          })
        }
      })
    })
    this.minHeight = Math.ceil(this.multiplierValue * + minHeight).toString() + "px";
    console.info('MIN Variant Height: ', this.minHeight)
    this.containerminHeight = Math.ceil(this.multiplierValue * + minHeight + containerHeader).toString() + "px";
    console.info('MIN Pitch Height: ', this.containerminHeight)
    this.emptyMinHeight = Math.ceil(this.multiplierValue * + (minHeight) + containerHeader). toString() + "px";
    console.info('EMPTY MIN Height: ', this.emptyMinHeight)
  }

  onChangeEditStatus(view_only: boolean){
    this.viewOnly = view_only
    this.viewOnlyUserConfirm = !view_only
  }

  onChangeVersion(version_id: string){
    this.currentNav.version_id = +version_id;
    this.getTeamWork();
  }

  canDeletePitch(pPitch: WorkstationFormatted): boolean {
    let canDelete: boolean = true
    //looks for subassemblies tied to the pitch if subassemblyies are found cannot delete
    if (pPitch.type === 'pitch'){
      this.pitchPairs.forEach(pitch =>{
        if (pitch.odd?.pitch_id === pPitch.pitch_id && pitch.odd?.type === 'subassembly') canDelete = false;
        if (pitch.even?.pitch_id === pPitch.pitch_id && pitch.even?.type === 'subassembly') canDelete = false;
      })
    }
    return canDelete
  }

  createPitchPairs(odd_workstations: any, even_workstations:any ){
    odd_workstations.map((workstation:any, index: any) => {
      let pitchPair: PitchPair = {
        odd: (workstation != undefined) ? workstation : undefined,
        even: (even_workstations[index] != undefined) ? even_workstations[index] : undefined
      }
      this.pitchPairs.push(pitchPair)

      if (workstation.hasOwnProperty('variant')){
        workstation.variant.forEach(v =>{
          this.workstationParentListArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString())
          this.workstationParentListArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-fluctuation')
          this.workstationParentListArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-periodic')
          this.workstationParentListArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-cycle')
          this.workstationParentListArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationFluctuationArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-fluctuation')
          this.workstationFluctuationArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationPeriodicArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-periodic')
          this.workstationPeriodicArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationCycleWasteArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-cycle')
          this.workstationCycleWasteArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationPlaceholderArray.push(workstation.pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')
        })
      }

      if(even_workstations[index] != undefined && even_workstations[index].hasOwnProperty('variant')){
        even_workstations[index].variant.forEach(v =>{
          this.workstationParentListArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString())
          this.workstationParentListArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-fluctuation')
          this.workstationParentListArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-periodic')
          this.workstationParentListArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-cycle')
          this.workstationParentListArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationFluctuationArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-fluctuation')
          this.workstationFluctuationArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationPeriodicArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-periodic')
          this.workstationPeriodicArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationCycleWasteArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-cycle')
          this.workstationCycleWasteArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')

          this.workstationPlaceholderArray.push(even_workstations[index].pitch_config_id.toString() + '-' + v.variant_id.toString() + '-placeholder')
        })
      }
    })
    console.log(this.pitchPairs)
  }

  onSaveWorkHeader(){
    this.saveStatus.message = 'Saved'
    this.saveStatus.color = 'green'
    this.saveWork()
  }

  onSaveWorkPitch(){
    this.saveStatus.message = 'Auto Saved'
    this.saveStatus.color = '#0277BD'
    this.saveWork()
  }

  onChangeDisplayErgoStatus(event: boolean) {
    console.group("on change display ergo")
    console.log(event)
    this.displayErgoScore = event
    if (this.displayErgoScore){
      console.log("in if")
      this.getTeamWork()
    }
    console.groupEnd()
  }
  
}